import * as ActionTypes from '../constants/actiontypes/auth';
import * as UserActionTypes from '../constants/actiontypes/user';
import * as Loadings from '../constants/loadings/auth';
import * as axios from 'axios';
import * as Text from '../constants/toasterText/auth';
import { toast } from 'react-toastify';
import JwtDecode from 'jwt-decode';
import * as R from 'ramda';

const toastConf = { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 };

const AuthReducer = (state = {
    isLoading: [],
    loggedIn: undefined,
    authError: undefined,
    registered: false,
    userId: undefined,
    error: undefined,
    resetByEmail: undefined,
    resetPasswordComplete: undefined,
    errorOnResetPassword: undefined,
    SMSWasSent: false,
    phoneConfirmed: false,
    roles: []
}, action) => {
    switch (action.type) {
        case ActionTypes.RESET_AUTH_STATE:
            state.isLoading = [];
            state.loggedIn = undefined;
            state.authError = undefined;
            state.registered = false;
            state.userId = undefined;
            state.error = undefined;
            state.resetByEmail = undefined;
            state.resetPasswordComplete = undefined;
            state.errorOnResetPassword = undefined;
            state.SMSWasSent = false;
            state.phoneConfirmed = false;
            return { ...state };
        case ActionTypes.AUTH_USER_REQUEST:
            if (!state.isLoading.includes(Loadings.AUTH_USER)) {
                state.isLoading.push(Loadings.AUTH_USER);
            }
            state.authError = undefined;
            state.loggedIn = undefined;
            return { ...state };
        case ActionTypes.AUTH_USER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.AUTH_USER);
            let authToken = action.data.jwtToken;
            if (authToken !== undefined) {
                localStorage.removeItem("access_token");
                localStorage.setItem("access_token", authToken);
                axios.defaults.headers.common['Authorization'] = "Bearer " + authToken;
                let authTokenDecoded = JwtDecode(authToken);
                let rolesAuth = authTokenDecoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
                if (!R.isNil(rolesAuth)) {
                    if (Array.isArray(rolesAuth)) {
                        state.roles = rolesAuth;
                    } else {
                        state.roles = [rolesAuth];
                    }
                }
            }
            state.loggedIn = false;
            state.authError = undefined;
            state.phoneConfirmed = true;
            return { ...state };
        case ActionTypes.AUTH_USER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.AUTH_USER);
            if (action.response.status === 403 || action.response.status === 400) {
                state.authError = 'invalidCredentials';
            }
            return { ...state, loggedIn: undefined };

        case ActionTypes.REGISTER_USER_REQUEST:
            if (!state.isLoading.includes(Loadings.REGISTER_USER)) {
                state.isLoading.push(Loadings.REGISTER_USER);
            }
            state.error = undefined;
            return { ...state };
        case ActionTypes.REGISTER_USER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.REGISTER_USER);
            state.registered = true;
            // state.userId = action.data.id;
            let authToken1 = action.data.jwtToken;
            if (authToken1 !== undefined) {
                localStorage.removeItem("access_token");
                localStorage.setItem("access_token", authToken1);
                axios.defaults.headers.common['Authorization'] = "Bearer " + authToken1;
                let authToken1Decoded = JwtDecode(authToken1);
                let rolesRegister = authToken1Decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
                if (!R.isNil(rolesRegister)) {
                    if (Array.isArray(rolesRegister)) {
                        state.roles = rolesRegister;
                    } else {
                        state.roles = [rolesRegister];
                    }
                }
            }
            state.loggedIn = true;
            state.authError = undefined;
            state.phoneConfirmed = true;
            return { ...state };
        case ActionTypes.REGISTER_USER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.REGISTER_USER);
            if (action.response.data !== undefined && action.response.data.errors !== undefined && action.response.data.errors.Email !== undefined && Array.isArray(action.response.data.errors.Email) && action.response.data.errors.Email[0] === "There's already a user with this email.") {
                state.error = 'email';
            }
            else {
                toast.error(Text.REGISTER_FAILED, toastConf);
            }
            return { ...state };
        case ActionTypes.RESET_PASSWORD_SUCCESS:
            state.resetByEmail = true;
            return { ...state };
        case ActionTypes.SET_NEWPASSWORD_SUCCESS:
            state.resetPasswordComplete = true;
            return { ...state };
        case ActionTypes.SET_NEWPASSWORD_FAILURE:
            state.errorOnResetPassword = 'error';
            return { ...state };

        case UserActionTypes.CHANGE_PHONENUMBER_REQUEST:
        case ActionTypes.SEND_OTP_CODE_REQUEST:
            if (!state.isLoading.includes(Loadings.SEND_PHONE_NUMBER)) {
                state.isLoading.push(Loadings.SEND_PHONE_NUMBER);
            }
            state.phoneConfirmed = false;
            state.SMSWasSent = false;
            state.authError = undefined;
            return { ...state };
        case UserActionTypes.CHANGE_PHONENUMBER_SUCCESS:
        case ActionTypes.SEND_OTP_CODE_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.SEND_PHONE_NUMBER);
            state.SMSWasSent = true;

            return { ...state };
        case UserActionTypes.CHANGE_PHONENUMBER_FAILURE:
        case ActionTypes.SEND_OTP_CODE_FAILURE:
            if (action.reason === 409) {
                state.authError = 'PhoneNumberTaken';
            } else {
                state.authError = 'OTPnotSent';
            }

            state.isLoading = state.isLoading.filter(l => l !== Loadings.SEND_PHONE_NUMBER);
            state.SMSWasSent = false;
            return { ...state };

        case ActionTypes.VERIFY_OTP_REQUEST:
            if (!state.isLoading.includes(Loadings.VERIFYING_NUMBER)) {
                state.isLoading.push(Loadings.VERIFYING_NUMBER);
            }
            return { ...state };
        case ActionTypes.VERIFY_OTP_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.VERIFYING_NUMBER);
            state.phoneConfirmed = true;
            toast.success("numéro de téléphone mis à jour avec succès", toastConf);

            return { ...state };
        case ActionTypes.VERIFY_OTP_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.VERIFYING_NUMBER);
            state.authError = 'OTPfailure';
            state.phoneConfirmed = false;
            toast.error("Le code OTP n'est pas valide", toastConf);
            return { ...state };

        case ActionTypes.SEND_MFA_CODE_REQUEST:
            if (!state.isLoading.includes(Loadings.VERIFYING_NUMBER)) {
                state.isLoading.push(Loadings.VERIFYING_NUMBER);
            }
            state.authError = undefined;
            return { ...state };
        case ActionTypes.SEND_MFA_CODE_SUCCESS:
            let jwtToken = action.data.jwtToken;
            if (jwtToken !== undefined) {
                localStorage.removeItem("access_token");
                localStorage.setItem("access_token", jwtToken);
                axios.defaults.headers.common['Authorization'] = "Bearer " + jwtToken;
                let decodedJwt = JwtDecode(jwtToken);
                let roles = decodedJwt["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
                if (!R.isNil(roles)) {
                    if (Array.isArray(roles)) {
                        state.roles = roles;
                    } else {
                        state.roles = [roles];
                    }
                }

            }
            state.isLoading = state.isLoading.filter(l => l !== Loadings.VERIFYING_NUMBER);
            state.loggedIn = true;
            return { ...state };
        case ActionTypes.SEND_MFA_CODE_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.VERIFYING_NUMBER);
            state.authError = 'WrongMfa';
            return { ...state };
        default:
            return state;
    }
};
export default AuthReducer;